import * as q from '@/services/api/request/query';
import { Query } from '../../request';

export interface TemplateSearchQuery {
  search: string;
  category: string;
  page: string;
}

export const encodeTemplateQuery = (query: TemplateSearchQuery): Query => ({
  search: q.string(query.search),
  category: q.string(query.category),
  page: q.string(query.page),
});
